// extracted by mini-css-extract-plugin
export default {"file-upload":"FileUpload_file-upload__ZX1ab","img-container":"FileUpload_img-container__g0+FC","img-upload":"FileUpload_img-upload__5ZpmS"};